class UIPhase {
    constructor(serverPhase, id, icon, fromPhases) {
        this.serverPhase = serverPhase;
        this.id = id;
        this.icon = icon;
        this.fromPhases = fromPhases;
    }

    translate(t) {
        return t(`auctions.phase.${this.id}.name`);
    }

    is(uiPhase) {
        return uiPhase === this;
    }
}

export const SUBMITTED = new UIPhase('SUBMITTED', 'submitted', 'chevron-circle-right', []);

export const PUBLISHED = new UIPhase('PUBLISHED', 'published', 'hourglass-half', [SUBMITTED]);

export const RUNNING = new UIPhase('OPEN', 'running', 'play-circle', [PUBLISHED]);

export const CLOSED = new UIPhase('CLOSED', 'closed', 'stop-circle', [RUNNING]);

export const CANCELLED = new UIPhase('REJECTED', 'cancelled', 'times-circle', [CLOSED]);

export const FINISHED = new UIPhase('FINISHED', 'finished', 'check-circle', [CLOSED]);

export const DELETED = new UIPhase('CANCELLED', 'deleted', 'ban', [SUBMITTED, PUBLISHED, RUNNING, CLOSED]);

export const getUIPhase = (serverPhase) => {
    let result = null;
    switch (serverPhase) {
        case 'SUBMITTED':
            result = SUBMITTED;
            break;
        case 'PUBLISHED':
            result = PUBLISHED;
            break;
        case 'OPEN':
            result = RUNNING;
            break;
        case 'CLOSED':
            result = CLOSED;
            break;
        case 'REJECTED':
            result = CANCELLED;
            break;
        case 'FINISHED':
            result = FINISHED;
            break;
        case 'CANCELLED':
            result = DELETED;
            break;
        default:
            throw new Error(`Unknown phase: ${serverPhase}`);
    }
    return result;
};

export const getAllUIPhases = () => [
    SUBMITTED,
    PUBLISHED,
    RUNNING,
    CLOSED,
    CANCELLED,
    FINISHED,
    DELETED,
];
